module.exports = __webpack_public_path__ + "img/living-will.104caec7.svg";